// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2p0AW","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2n3uz","obliqueLine":"membershipbadge_obliqueLine__6An0M"};